import { Link } from "react-router-dom";
import { CampingRoute } from "../../router/CampingRoute";
import { Map } from "../../components/Map";
import Modal from "react-modal";
import { useState } from "react";
import { LotPeople, LotState } from "../../components/Map/people";
import { Burger } from "../../header/Burger";

function toStateDisponibility(state: LotState) {
  switch (state) {
    case LotState.SeasonFree:
    case LotState.PassengerFree:
    case LotState.PassengerTent:
      return "Libre";
    case LotState.SeasonRented:
      return "Occupé";
    case LotState.Owner:
      return "Au propriétaires";
  }
}

function toStateType(state: LotState) {
  switch (state) {
    case LotState.SeasonFree:
    case LotState.SeasonRented:
      return "Saisonniers";
    case LotState.PassengerFree:
      return "Passagers";
    case LotState.PassengerTent:
      return "Passagers en tente";
    case LotState.Owner:
      return "Au propriétaires";
  }
}

const lotLegend = [
  {
    label: "Saisonnier libre",
    colorClass: "bg-white border border-stone-400",
  },
  {
    label: "Saisonnier loué",
    colorClass: "bg-black border border-black",
  },
  {
    label: "Passager libre",
    colorClass: "bg-sky-400 border border-sky-500",
  },
];

function MapPage() {
  const [selectedLot, setSelectedLot] = useState<LotPeople>();

  return (
    <div className="w-full max-w-[1150px] px-3 py-4 sm:px-4 sm:py-6">
      <div className="rounded-3xl border border-emerald-100 bg-gradient-to-br from-white via-emerald-50/60 to-cyan-50/70 p-4 shadow-[0_18px_45px_-25px_rgba(2,120,38,0.45)] sm:p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="text-[24px] font-bold text-emerald-950">Plan du camping</h1>
            <p className="mt-1 max-w-[620px] text-[13px] leading-relaxed text-emerald-900/80 sm:text-[14px]">
              Cliquez sur un terrain pour voir ses infos. Le plan reste
              consultable sur mobile avec défilement horizontal.
            </p>
          </div>
          <Link
            to="/map/print"
            target="_blank"
            className="rounded-full border border-emerald-300 bg-white px-4 py-2 text-[13px] font-semibold text-emerald-900 transition hover:border-emerald-500 hover:bg-emerald-50"
          >
            Version imprimable
          </Link>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {lotLegend.map((item) => (
            <div
              key={item.label}
              className="inline-flex items-center gap-2 rounded-full border border-emerald-200/90 bg-white/90 px-3 py-1.5 text-[12px] text-emerald-950"
            >
              <span
                className={`h-3 w-3 rounded-sm ${item.colorClass}`}
                aria-hidden
              />
              <span>{item.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-4 overflow-x-auto rounded-2xl border border-emerald-200 bg-white p-2 shadow-inner sm:p-3">
          <div className="min-w-[760px]">
            <Map onClick={setSelectedLot} />
          </div>
        </div>
      </div>

      {selectedLot && (
        <Modal
          className="w-full max-w-[540px] overflow-hidden rounded-2xl border border-emerald-100 bg-white shadow-2xl outline-none"
          overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-emerald-950/75 p-3 backdrop-blur-[2px]"
          isOpen={Boolean(selectedLot)}
          contentLabel="Informations terrain"
          ariaHideApp={false}
        >
          <div className="flex items-center border-b border-emerald-100 bg-gradient-to-r from-emerald-50 to-cyan-50 px-4 py-3">
            <h1 className="m-0 flex-grow pr-5 text-[18px] font-bold text-emerald-950">
              Informations sur le terrain {selectedLot.name}
            </h1>
            <Burger isOpen onClick={() => setSelectedLot(undefined)} />
          </div>
          <div className="px-4 py-4 text-[15px] text-stone-800 [&_tr>td:first-child]:w-[160px] [&_tr>td]:pb-2 [&_tr>td:first-child]:font-semibold [&_tr>td:first-child]:text-stone-600">
            <table>
              <tbody>
                {selectedLot.people && (
                  <tr>
                    <td>Campeur</td>
                    <td>{selectedLot.people.join(", ")}</td>
                  </tr>
                )}
                <tr>
                  <td>Disponibilité</td>
                  <td>{toStateDisponibility(selectedLot.state)}</td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>{toStateType(selectedLot.state)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal>
      )}
    </div>
  );
}

export const MapRoute: CampingRoute = {
  title: "Plan",
  path: "/plan",
  element: <MapPage />,
};
